/// <reference path="../walkinManagerKiosk.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />


module Meevo.Plugins.WalkinManagerKiosk.Terms {

    class TermsModalController {
        static $inject = [
          '$mdDialog',
          'terms'
        ];

        public termsText: string;

        constructor(
          protected $mdDialog: ng.material.IDialogService,
          protected terms: any
        ) {
          this.termsText = terms;
        };

        public ok (): void {
            this.$mdDialog.hide();
        }
    }

    angular.module('meevo.plugins.walkinManagerKiosk')
        .controller('meevo.plugins.walkinManagerKiosk.terms.TermsModalController', TermsModalController);
}
